import styled from "styled-components";

export const Logo = styled.div`
  width: 200px;
  height: 60px;
  background-image: url(/assets/img/logo.jpg);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-color: #ffffff;
`;

export const LogoCenter = styled.div`
  width: 100%;
  height: 60px;
  background-image: url(/assets/img/logo.jpg);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;

export const Favicon = styled.div`
  width: 100%;
  height: 200px;
  background-image: url(/assets/img/favicon.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-color: #ffffff;
`;

export const IntroImg = styled.div`
  width: 100%;
  height: 200px;
  background-image: url(/assets/img/intro.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;

export const WhiteBoxWrapper = styled.div`
  width: 100%;

  background-color: #ffffff;
  border-radius: 10px;
  padding: 15px;
  color: #123663;
  margin-top: 10px;
  font-family: "Poppins", sans-serif;
  margin-bottom: 10px;
`;

export const VideoWrapper = styled.div`
  max-width: 500px;
  max-height: 180px;
  position: relative;
  display: flex;
  justify-content: center;
  background-color: #fff;
  align-items: center;
  padding: 0;
  border-radius: 10px;
  margin: 0 auto;
  overflow: hidden;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0px 3px 5px 5px #ccc;

  video {
    border-radius: 10px;
  }
`;

export const VideoScanBar = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  height: 15px;
  background: #ff00005a;
  animation: scan 2s ease-in-out infinite;

  @keyframes scan {
    0% {
      top: 100%; /* Pasek zaczyna poniżej */
    }
    50% {
      top: 0; /* Pasek przesuwa się na górę */
    }
    100% {
      top: 100%; /* Pasek wraca na dół */
    }
  }
`;
